import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { UsersFormDataTenantUserInvite } from '@/common/viewModels/users/form/data/UsersFormDataTenantUserInvite';
import { UsersFormStateTenantUserInvite } from '@/common/viewModels/users/form/state/UsersFormStateTenantUserInvite';
import { ItemViewModel } from '@/common/viewModels';
import { TenantRoleType } from '@/common/viewModels/Enums';
import {TelstraUIVueDialog} from '@/external/telstra-ui-vue/components';

@Component({
  components: {
    TelstraUIVueDialog,
  },
})

export default class InviteUserModal extends Vue {
  @Prop({ required: true }) data!: UsersFormDataTenantUserInvite;
  @Prop({ required: true }) state!: UsersFormStateTenantUserInvite;
  @Prop({ required: true }) serverError!: string;
  @Prop({ default: false }) isLoading!: boolean;
  @Prop({ default: true }) disableActionBtn!: boolean;

  roleOptions: ItemViewModel[] = [
    { text: 'Tenancy Administrator', value: TenantRoleType.TenancyAdministrator, disabled: false },
    { text: 'Tenancy Manager', value: TenantRoleType.TenancyManager, disabled: false },
    { text: 'Tenancy Reader', value: TenantRoleType.TenancyReader, disabled: false },
  ];

  @Emit()
  showModal(): void {
    this.$emit('resetInviteUserForm');
    (this.$refs.modalInviteUser as any).show();
  }

  hideModal(): void {
    (this.$refs.modalInviteUser as any).hide();
  }

  @Emit()
  onFormInputChange(inputEvent: any) {
    const target: any = inputEvent.target;
    this.$emit('inviteUserFormInputChange', target.name, target.value);
  }

  @Emit()
  onInviteUser(): void {
    this.$emit('inviteUserToTenancy');
    this.$nextTick(() => (this.$refs.vForm as any).validate());
  }
}
